export default __webpack_public_path__ + "static/media/inventory_app_preview.7ce774de.png";